module.exports = __webpack_public_path__ + "img/big_1_9.7f4a155b.png";